export default "__VITE_ASSET__6joKBCxw__"